module.exports = __webpack_public_path__ + "static/media/Gustavo Pessini‎ 01.5ca21dea.jpg";